import { LuPen, LuX } from 'react-icons/lu';

export default function ReviewEditButton({
  isReviewFlow,
  reviewLocked,
  onEdit,
  onCancel,
  submissionStatus, // 👈 ADD THIS PROP
}) {
  if (!isReviewFlow) return null;

  const isRejected = submissionStatus === 'rejected';

  // ❌ Rejected submissions: no edit, no cancel
  if (isRejected) {
    return (
      <button
        type="button"
        disabled
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          background: '#f3f4f6',
          color: '#6b7280',
          border: '1px solid #e5e7eb',
          padding: '6px 14px',
          borderRadius: 8,
          fontSize: 12,
          fontWeight: 900,
          cursor: 'not-allowed',
        }}
      >
        Done
      </button>
    );
  }

  // ✅ Existing behavior for non-rejected
  return (
    <button
      type="button"
      onClick={() => {
        if (reviewLocked && typeof onEdit === 'function') onEdit();
        if (!reviewLocked && typeof onCancel === 'function') onCancel();
      }}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: '#ef4444',
        color: '#ffffff',
        border: '1px solid #ef4444',
        padding: '6px 14px 6px 10px',
        borderRadius: 8,
        fontSize: 12,
        fontWeight: 900,
        cursor: 'pointer',
        lineHeight: 1,
      }}
    >
      {reviewLocked ? (
        <>
          <LuPen size={14} />
          Edit
        </>
      ) : (
        <>
          <LuX size={14} />
          Cancel
        </>
      )}
    </button>
  );
}
